<template>
<div v-if="mostrar" id="prinOrden" style="text-align: center; font-size: 14px;">
        <div class="ticket">
            <div class="text-center" style="text-align: center; font-size: 14px;">
                <b-row>
                    <b-col>
                        <template>
                            <h4 style="font-size: 20px;">Detalles de Orden</h4>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template>
                             <b>{{ nombreComercial }}</b> 
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template>
                            <b>RUC:</b>{{ this.$store.getters.userData.cuenta.idEmisor }}
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template>
                           <b>Dirección</b> {{ direccion }}
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template>
                          <b>Teléfono</b> {{ telefono }}
                        </template>
                    </b-col>
                </b-row>
            </div>
            <!-- Datos del receptor -->
            <div class="text-left" style="font-size: 14px;">
                <hr>
                    <template>
                        <div style="display: inline-block; float: left; width: 100%; font-size: 15px;">
                            Cliente: <b>{{ordenDetalle.ordenPago.receptor.razonSocial}}</b>
                        </div>
                        <div style="display: inline-block; float: left; width: 100%; font-size: 15px;">
                            Documento: <b>{{ordenDetalle.ordenPago.receptor.nro}}</b>
                        </div>
                    </template>
                    <template>
                        <div style="display: inline-block; float: left; width: 100%; font-size: 15px;">
                            Fecha: <b>{{ordenDetalle.created_at | moment('D/M/Y')}}</b>-<b>{{ordenDetalle.created_at | moment('hh:mm:ss A')}}</b>
                        </div>
                    </template>
                    <template>
                        <div style="display: inline-block; float: rigth; width: 50%; font-size: 15px;">
                            Mozo: <b>{{ordenDetalle.ordenPago.adicional.username}}</b>
                        </div>
                        <div style="display: inline-block; float: rigth; width: 50%; font-size: 17px;">
                            N° Mesa: <b style="font-size:17px;">{{ ordenDetalle.ordenPago.tag3 }}</b>
                        </div>
                        <div style="display: inline-block; float: rigth; width: 100%; font-size: 15px;">
                            Observaciones: <b>{{ordenDetalle.ordenPago.observaciones}}</b>
                        </div>
                    </template>
            </div>
            <hr>
            <b-row>
                <b-col>
                    <div style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                        <b>ART&Iacute;CULO</b>
                    </div>
                    <div  style="text-align: right; font-size: 14px; float:rigth; display: inline-block; width: 50%;">
                        <b>SUBTOTAL</b>
                    </div>
                </b-col>
            </b-row>
            <template>
            <b-row v-for="(item, index) in ordenDetalle.ordenPago.items" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div>
                                {{item.cantidad}}. {{item.unidadMedidaCantidad}} {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left:15px; font-size:13px; text-transform:lowercase;">
                            {{ item.observacionItem }}
                        </span>
                    </div>
                    <div style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span>{{(item.cantidad * item.precioVentaUnitario).toFixed(2)}}</span>
                    </div>
                </b-col>
            </b-row>
            </template><br>
            <b-row>
                <b-col cols="2"></b-col>
                    <b-col style="text-align:center;margin-top:20px">
                        <template>
                            TOTAL: <b>{{ordenDetalle.ordenPago.moneda.simbolo}} {{(ordenDetalle.ordenPago.totales.importeTotal).toFixed(2)}}</b>
                        </template>
                    </b-col>
                <b-col cols="2"></b-col>
            </b-row>
            <b-row>
                <b-col style="text-align:center;margin-top:20px">
                    <template>
                        <b style="font-size:12px">----------------------------------------------------------------</b>
                    </template>
                 </b-col>
            </b-row> 
            <b-row>
                <b-col style="text-align:center">
                    <template>
                        <b style="font-size:12px">No es un comprobante</b>
                    </template>
                    </b-col>
            </b-row> 
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name:'DetalleOrdenCaja',
    props:['detallesorden','printOrden'],
    data() {
        return {
            ordenDetalle:{},
            mostrar: false,
            telefono:'',
            nombreComercial:'',
            direccion:'',
            paginaWeb:'',
            correo:'',
            textoPersonalizado1:'',
            textoPersonalizado2:''
        }
    },
     watch: {
         printOrden: function () {
            if(this.printOrden == true){
                var printContents = document.getElementById("prinOrden").innerHTML
                var myWindow = window.open("", "MsgWindow", "width=400,height=800")
                myWindow.document.body.style.fontSize='10px'
                myWindow.document.body.style.textAlign='center'
                myWindow.document.write(printContents)
                myWindow.print(printContents)
                myWindow.close()
            }
        }
       
    },
    mounted(){
      this.mostrarData() 
      this.getDataImpresion() 
    },
    methods:{
        mostrarData(){
            this.ordenDetalle = this.detallesorden
            console.log(this.ordenDetalle)
            if(this.ordenDetalle !=''){
                this.mostrar = true
            }
           
        },
        getDataImpresion: function () {
                axios
                .post(process.env.VUE_APP_API_URL + 'movil/informacioncliente/mostrar', {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.dataLogo(response.data.response)
                ))
                .catch(error => (
                    console.log(error)
                ))
            },
        dataLogo: function (data) {
                this.telefono = data.telefono
                this.nombreComercial = data.nombreComercial
                this.direccion =  data.direccion
                this.paginaWeb = data.paginaWeb
                this.correo = data.correo
                this.textoPersonalizado1 = data.textoPersonalizado1
                this.textoPersonalizado2 = data.textoPersonalizado2
            },
    }
}
</script>
<style lang="scss" scoped>
.ticket{
        border: 1px solid #ccc;
        border-radius: 10px;
        padding: 10px;
        font-family: 'Six Caps', sans-serif;
    }
</style>